import { HttpClient, jrpcRequest } from '@httpClient/index';
import AuthenticationService from './service';
import { AUTHENTICATION_BASE_URL, AUTHENTICATION_JSONRPC_ENTRY_POINT } from './config';
import jrpcConfig from './jsonrpcConfig';
import ActionNames from './actionNames';

export default (): HttpClient<ActionNames> =>
  new AuthenticationService(jrpcRequest(AUTHENTICATION_JSONRPC_ENTRY_POINT, jrpcConfig), {
    baseURL: AUTHENTICATION_BASE_URL,
  });
